import $ from 'zepto';
var Util = {
    getSearch: function(key) {
        return new RegExp('[&?]' + key + '=([^&]*)', 'i').test(location.search) ? decodeURIComponent(RegExp.$1) : '';
    },
    isNull: function(a) {
        return typeof a == "object" && !a;
    },
    getUrlParam: function(url, parameter) {
        url = url || location.href;
        var result = url.match(new RegExp("[\#|\?]([^#]*)[\#|\?]?"));
        url = "&" + (this.isNull(result) ? "" : result[1]);
        result = url.match(new RegExp("&" + parameter + "=", "i"));
        return this.isNull(result) ? undefined : url.substr(result.index + 1).split("&")[0].split("=")[1];
    },
    isWeixin: function() {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return true;
        } else {
            return false;
        }
    },
    isIpad: function() {
        var getUA = navigator.userAgent.toLowerCase();
        return /ipad/i.test(getUA);
    },
    isIOS: function() {
        var i = /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/;
        return i.test(navigator.userAgent)
    },
    isAndroid: function() {
        var i = /\bAndroid([^;]+)/;
        return i.test(navigator.userAgent)

    },
    isShouLei: function() {
        var ua = navigator.userAgent.toLowerCase();
        if (window.XLJSWebViewBridge || ua.match(/Thunder/i) == "thunder") {
            return true;
        } else {
            return false;
        }
    },
    ajax: function(url, success, error) {
        $.ajax({
            url: url,
            dataType: 'jsonp',
            type: 'GET',
            timeout: 10 * 1000,
            success: function(data) {
                success && success(data)
            },
            error: function() {
                error && error();
            }
        });
    },
    initEvents: function(Events) {
        var key, keyArr, delElems, elems, events;
        var spiltElems = function(elems) {
            return elems.split('&').join(',');
        }
        for (key in Events) {
            keyArr = key.split('|');
            switch (keyArr.length) {
                case 3:
                    delElems = spiltElems(keyArr[0]);
                    elems = spiltElems(keyArr[1]);
                    events = spiltElems(keyArr[2]);
                    delElems = document;
                    $(delElems).on(events, elems, Events[key]);
                    break;
                case 2:
                    elems = spiltElems(keyArr[0]);
                    events = spiltElems(keyArr[1]);
                    $(elems).on(events, Events[key]);
                    break;
                default:
                    break;
            }
        }
    },
    initUserInfo: function(callback) {
        client.data.getUserInfo({
            "forceLogin": 0
        }, function(rs) {
            Util.clearShouLeiCookie();
            window.SLUserInfo = null;
            if (rs.userInfo && rs.userInfo.userID) {
                window.SLUserInfo = rs;
                Util.setShouLeiCookie(rs.userInfo);
                if (typeof callback == 'function') {
                    callback();
                }
            }
        })
    },
    setShouLeiCookie: function(data) {
        var config = {
            userID: "userid",
            sessionID: "sessionid",
            nickName: "usernick"
        }
        for (var i in data) {
            if (config[i]) {
                setCookie(config[i], encodeURIComponent(data[i]), 24, 1);
            }
        }
    },
    clearShouLeiCookie: function() {
        clearCookie();
    },
    download: function(url, name, ref) {
        try {
            var data = {
                'max': 1,
                "type": 1,
                "list": [{
                    'name': name || '',
                    'url': url,
                    'ref_url': ref || location.href
                }]
            }
            window.share.addTasks(JSON.stringify(data));
        } catch (e) {
            if (Util.isShouLei()) {
                client.data.addDownloadTask({
                    'name': name || '',
                    'url': url,
                    'refurl': ref || location.href
                })
            } else {
                location.href = "http://act.vip.xunlei.com/vip/download/?downloadUrl=" + url;
            }
        }
    },
    ipadSLhack: function() { //iapd手雷input输入出现问题hack,如果发现ipad手雷input出现黑框，可以通过这个解决
        if (this.isIpad()) {
            var top = parseInt($(window).scrollTop()) - 3;
            $(window).scrollTop(top);
        }
    }
};

export default Util;



// WEBPACK FOOTER //
// ./src/common/util.js